import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getLetterInfo = (authNo: any, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_LETTER_INFO_REQUEST });

  return api.authorization.letter.getInfo(authNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_LETTER_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_LETTER_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  